import React from 'react';
import styled from 'styled-components';
import './styles.scss';

const CTAButton = styled.a``;

CTAButton.defaultProps = {
    $borderRadius: '55px'
};

const CTA = ({ctaHref, ctaText, id }) => {
    const handleMouseMove = (e) => {
        const x = e.pageX - e.target.offsetLeft;
        const y = e.pageY - e.target.offsetTop;
        e.target.style.setProperty('--x', x + 'px');
        e.target.style.setProperty('--y', y + 'px');
    };

    return (
        <div style={{display: 'flex'}}>
            <CTAButton href={ctaHref} className="button" onMouseMove={handleMouseMove} id={id ? id : null}>
                <span style={{margin: "0"}}>{ctaText}</span>
            </CTAButton>
        </div>
    )
}

export default CTA;